import { render } from "./app-system-calendar.vue?vue&type=template&id=a623ce56&scoped=true&ts=true"
import script from "./app-system-calendar.vue?vue&type=script&lang=ts"
export * from "./app-system-calendar.vue?vue&type=script&lang=ts"

import "./app-system-calendar.vue?vue&type=style&index=0&id=a623ce56&lang=scss&scoped=true"

import exportComponent from "D:\\shine\\shine-project\\dispatch-big-screen-pc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a623ce56"]])

export default __exports__